
<!-- 他人代付只供钱包充值使用 -->
<template>
    <div>
        <loading :show="payLoading" text="支付中..." />
    </div>
</template>

<script>
import Loading from "@/components/base/loading/loading.vue";
import {
    submitParkingOrderFromApp,
    getPaymentOnBehalfValidCode,
} from "@/api/apiNoAuth";
import { calcPayChannel } from "@/libs/env";
import { mapGetters } from "vuex";
import { obj2Param } from "@/libs/tools";
export default {
    name: "payByOthers",
    components: {
        Loading,
    },

    data() {
        return {
            payLoading: false,
        };
    },

    computed: {
        ...mapGetters({ appEnv: "getAppEnv" }),
    },

    async mounted() {
        let { data } = await getPaymentOnBehalfValidCode({ validCode: this.$route.query.validCode || '1' })
        if (data == true) {
            this.payNow();
        } else {
            this.$toast('二维码已失效')
        }
    },
    methods: {
        payNow() {
            let money = Number(this.$route.query.money);
            money = (money > 0 ? money : 0).toFixed(2);
            let couponMoney = Number(this.$route.query.couponMoney);
            let obj = {
                business: "walletup",
                parkType: 1,
                certId: localStorage.getItem("openId"),

                orderInfo: [
                    {
                        buyer: this.$route.query.userId,
                        couponMoney: couponMoney,
                        couponRandomMoney: 0,
                        couponTicketMoney: 0,
                        goodDetail: "余额充值",
                        goodSubject: "余额充值",
                        orderMoney: Number(money) + Number(couponMoney),
                        payForMoney: 0,
                        realMoney: money,
                        scanDiscount: 0,
                        scanDiscountConfigId: null,
                    },
                ],
                payChannel: calcPayChannel(this.appEnv, 2),
                totalRealMoney: money,
            };
            this.payLoading = true;

            submitParkingOrderFromApp(obj)
                .then((res) => {
                    if (this.appEnv.appEnv == "miniprogram") {
                        this.miniprogramHandle(res);
                    } else {
                        window.location.href = res.data.payUrl;
                    }
                })
                .finally(() => {
                    this.payLoading = false;
                });
        },

        miniprogramHandle(res) {
            let signParam = res.data.signParam;
            let obj = {
                realMoney: this.money,
                timeStamp: signParam.timeStamp,
                nonceStr: signParam.nonceStr,
                package: encodeURIComponent(signParam.package),
                sign: encodeURIComponent(signParam.sign),
                signType: signParam.signType,
            };
            let str = obj2Param(obj);
            wx.miniProgram.navigateTo({
                url: `/pages/tab2/pay/pay?${str}`,
            });
        },
    },
};
</script>
<style>
</style>
